module.exports = {"key":"hello Spanish","submit":"Enviar opinión","hide":"Ocultar","skip":"Siguiente pregunta","placeholder":"Describe cómo te sientes acerca de esto..."}


//////////////////
// WEBPACK FOOTER
// ./src/translations/es.json
// module id = 442
// module chunks = 0